// extracted by css-extract-rspack-plugin
export default {"emptyState":"EmptyState-module__emptyState__zgF3JBN","emptyStateHeading":"EmptyState-module__emptyStateHeading__ox8OIsC"};